import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ui-multirow-basic',
  templateUrl: './ui-multirow-basic.component.html',
  styleUrls: ['./ui-multirow-basic.component.scss']
})
export class UiMultirowBasicComponent implements OnInit {

  @Input() type:string = 'email'; /* email | mobile */
  @Input() placeholderVal:string = '';
  searchHasData:boolean = false;
  searchTerm: string = '';
  preferred: any = '';
  constructor() { }

  ngOnInit() {
    this.placeholderVal = "Enter " + this.type;
  }

  rows:any = [];
  addRow() {
    var objDummy = {};
    this.rows.push(objDummy);
    this.searchHasData = true;
  }
  removeRow(){
    this.rows.pop();
    if(0==this.rows.length && !this.searchTerm) this.searchHasData = false;
  }
  modelChanged(e) {
    if(this.searchTerm) this.searchHasData = true;
    else if(0==this.rows.length) this.searchHasData = false;
  }

}
